"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPrefetchProductListener = exports.setNavigateProductListener = exports.setFetchProductsListener = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setFetchProductsListener = function (listener) {
    new databus_1.Databus({ name: constants_1.FETCH_PRODUCTS }).addEventListener({
        listener: listener,
    });
};
exports.setFetchProductsListener = setFetchProductsListener;
var setNavigateProductListener = function (listener) {
    new databus_1.Databus({ name: constants_1.NAVIGATE_TO_PRODUCT }).addEventListener({
        listener: listener,
    });
};
exports.setNavigateProductListener = setNavigateProductListener;
var setPrefetchProductListener = function (listener) {
    new databus_1.Databus({ name: constants_1.PREFETCH_PRODUCT }).addEventListener({
        listener: listener,
    });
};
exports.setPrefetchProductListener = setPrefetchProductListener;
